import { useEffect, useRef, useState } from "react";
import "./accordion.scss";
import { greenDownArrow, whiteDownArrow } from "../../source";

export const CustomAccordion = ({ items, firstActive = false }) => {
  const [openIndex, setOpenIndex] = useState(firstActive === true ? 0 : "");
  const activeAccordionRef = useRef(null);

  const handleItemClick = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const scrollToActiveAccordion = () => {
    if (activeAccordionRef.current) {
      activeAccordionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  useEffect(() => {
    scrollToActiveAccordion();
  }, [openIndex]);

  return (
    <>
      <div className="accordion_container">
        {items.map((item, index) => (
          <div
            className={`accordion-wrapper ${
              openIndex === index ? "active" : ""
            }`}
            key={index}
            ref={openIndex === index ? activeAccordionRef : null}
          >
            <div
              className="accordion-title"
              onClick={() => handleItemClick(index)}
            >
              <span className="title-text">{item.title}</span>
              <div className="open-close-wrapper">
                <img
                  className="open-close"
                  alt="open and close icons"
                  src={openIndex === index ? whiteDownArrow : greenDownArrow}
                />
              </div>
            </div>
            <div
              className={`accordion-item ${
                openIndex === index ? "active" : ""
              }`}
            >
              <div
                className="accordion-content"
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
